// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 1C8.41015 1 5.5 3.91015 5.5 7.5V9H3V23H21V9H18.5V7.5C18.5 3.91015 15.5899 1 12 1ZM16.5 7.5V9H7.5V7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5ZM7 12.5039H9.00391V15H7V12.5039ZM7 16.5H9.00391V19.0039H7V16.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-git-repository-private-filled')
export default class GitRepositoryPrivateFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'git-repository-private-filled',
    }
  }
}
